import { render, staticRenderFns } from "./inport-file.vue?vue&type=template&id=53bf56b5"
import script from "./inport-file.vue?vue&type=script&lang=js"
export * from "./inport-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports